import { Box, ButtonBase } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { dateFormat } from "../../misc/dates";
import { useWorkspace } from "../../misc/Workspace";

// DayWeekToggle flips a phone between the day list and the week list, keeping the date
// that's on screen
export function DayWeekToggle(props: {
    value: "day" | "week";

    // date is the day on screen, or a day of the week on screen
    date: string;
}) {
    const ws = useWorkspace();
    const navigate = useNavigate();

    const go = (to: "day" | "week") => {
        if (to === props.value) return;

        if (to === "week") {
            navigate(ws.path("/tasks/calendar") + "?mode=week&date=" + props.date);
            return;
        }

        // the week opens on today when today is in it, else on its first day
        const start = moment(props.date, dateFormat).startOf("isoWeek");
        const end = start.clone().add(6, "days");
        const day = moment().isBetween(start, end, "day", "[]") ? moment() : start;

        navigate(ws.path("/tasks/day") + "?date=" + day.format(dateFormat));
    };

    // a pill on a grey track: the view that's on screen is the raised white one
    return (
        <Box role="group" aria-label="View" sx={{
            flexShrink: 0,
            display: "flex",
            p: "2px",
            borderRadius: 999,
            bgcolor: "grey.200",
        }}>
            {options.map(option => {
                const selected = option.value === props.value;

                return (
                    <ButtonBase
                        key={option.value}
                        aria-pressed={selected}
                        onClick={() => go(option.value)}
                        sx={{
                            px: 1.25,
                            height: 26,
                            borderRadius: 999,
                            fontSize: 12,
                            fontWeight: selected ? 600 : 500,
                            color: selected ? "text.primary" : "text.secondary",
                            bgcolor: selected ? "background.paper" : "transparent",
                            boxShadow: selected ? "0 1px 2px rgba(0, 0, 0, 0.15)" : "none",
                            transition: "background-color 150ms, color 150ms, box-shadow 150ms",
                        }}
                    >
                        {option.label}
                    </ButtonBase>
                );
            })}
        </Box>
    );
}

const options: { value: "day" | "week"; label: string }[] = [
    { value: "day", label: "Day" },
    { value: "week", label: "Week" },
];
